import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import StatusLabel from 'LuxKit/Label/StatusLabel'

const StatusLabelWithPrintBorder = styled(StatusLabel)`
  @media print {
    &.kind-tertiary {
      border: 1px solid ${props => props.theme.palette.neutral.default.five};
    }
  }
`

interface Props {
  className?: string
}

function BookedLabel({ className }: Props) {
  const intl = useIntl()
  return (
    <StatusLabelWithPrintBorder variant="confirmation" className={className}>
      {intl.formatMessage({
        id: '1oji2xCHAY',
        defaultMessage: 'Booked',
        description: 'Label indicating a trip item has been booked',
      })}
    </StatusLabelWithPrintBorder>
  )
}

export default BookedLabel
